var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    { attrs: { "align-h": "center" } },
    [
      _c(
        "b-col",
        { staticClass: "px-1", attrs: { sm: "6" } },
        [
          _c(
            "b-alert",
            {
              staticClass: "text-center p-2 mb-2",
              attrs: { show: "", variant: "info" },
            },
            [
              _c("strong", [_vm._v("To fit Artwork Size")]),
              _c("br"),
              _c("em", [_c("small", [_vm._v("(as entered)")])]),
              _c("br"),
              !_vm.artworkDimensions.name
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.artworkDimensions.width) +
                        "x" +
                        _vm._s(_vm.artworkDimensions.length) +
                        "mm "
                    ),
                  ])
                : _c("span", [_vm._v(_vm._s(_vm.artworkDimensions.name))]),
            ]
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "px-1", attrs: { sm: "6" } },
        [
          _c(
            "b-alert",
            {
              staticClass: "text-center p-2 mb-2",
              attrs: { show: "", variant: "success" },
            },
            [
              !_vm.hasMount
                ? _c("div", { staticClass: "rebate-size" }, [
                    _c("strong", [_vm._v("Visible Internal Size")]),
                    _c("br"),
                    _c("em", [_c("small", [_vm._v("(approximate)")])]),
                    _c("br"),
                    _vm._v(
                      _vm._s(_vm.visibleInternalDimensions.width) +
                        "x" +
                        _vm._s(_vm.visibleInternalDimensions.length) +
                        "mm"
                    ),
                  ])
                : _c("div", { staticClass: "aperture-size" }, [
                    _c("strong", [_vm._v("Mount Opening Size")]),
                    _c("br"),
                    _c("em", [_c("small", [_vm._v("(aperture size)")])]),
                    _c("br"),
                    _vm._v(
                      _vm._s(_vm.apertureDimensions.width) +
                        "x" +
                        _vm._s(_vm.apertureDimensions.length) +
                        "mm"
                    ),
                  ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "px-1", attrs: { sm: "6" } },
        [
          _c(
            "b-alert",
            {
              staticClass: "text-center p-2 mb-2",
              attrs: { show: "", variant: "danger" },
            },
            [
              _c("strong", [_vm._v("Glass Size")]),
              _c("br"),
              _c("em", [_c("small", [_vm._v("(size of the glass)")])]),
              _c("br"),
              _vm._v(
                _vm._s(_vm.glassDimensions.width) +
                  "x" +
                  _vm._s(_vm.glassDimensions.length) +
                  "mm"
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }